export const routes = {
  activities: {
    complete: (id: string) => `/activities/${id}/complete`,
    create: '/activities',
    delete: (id: string) => `/activities/${id}`,
    get: (id: string) => `/activities/${id}`,
    report: (id: string) => `/activities/${id}/report.csv`,
    submissions: (id: string) => `/activities/${id}/submissions`,
    update: (id: string) => `/activities/${id}`,
  },
  assets: {
    create: '/assets',
    delete: (id: string) => `/assets/${id}`,
    list: '/assets',
    update: (id: string) => `/assets/${id}`,
  },
  changeRequests: {
    get: (id: string) => `/change_requests/${id}`,
    post: '/change_requests.json',
  },
  channels: {
    detail: {
      get: (id: string) => `/channels/${id}/detail`,
    },
    entities: {
      get: (id: string) => `/channels/${id}/content`,
    },
    find: '/channels',
  },
  community: {
    autoComplete: '/auto_completes/community_users',
    changeRole: '/admin/memberships',
    find: '/communities',
    get: (id: string) => `/communities/${id}`,
    getPublic: (id: string) => `/communities/${id}/public`,
    invitationToken: (communityId: string) => `/communities/${communityId}/public_invite`,
    join: (id: string) => `/communities/${id}/join`,
    leave: (id: string) => `/communities/${id}/join`,
    members: (id: string) => `/communities/${id}/members`,
    notifications: {
      get: (id: string) => `/communities/${id}/user_notifications_settings`,
      update: (id: string) => `/communities/${id}/user_notifications_settings`,
    },
    update: (id: string) => `/communities/${id}.json`,
  },
  consents: {
    accept: '/consents/accept',
    find: '/consents',
  },
  contentObjects: {
    bookmark: {
      create: (id: string) => `/content_objects/${id}/bookmark`,
      delete: (id: string) => `/content_objects/${id}/bookmark`,
    },
    bookmarks: '/content_objects/bookmarks',
    comment: {
      create: '/content_objects',
      delete: (id: string) => `/content_objects/${id}`,
      edit: (id: string) => `/content_objects/${id}`,
      get: (id: string) => `/content_objects/${id}/comments`,
    },
    feed: '/content_objects/feed',
    get: (id: string) => `/content_objects/${id}`,
    index: '/content_objects',
    like: {
      create: (id: string) => `/content_objects/${id}/like`,
      delete: (id: string) => `/content_objects/${id}/like`,
    },
    report: '/abuse_reports',
  },
  evaluations: {
    create: '/evaluations',
  },
  events: {
    create: '/events',
    createFeedback: (id: string) => `/events/${id}/feedback`,
    delete: (id: string) => `/events/${id}`,
    enter: (id: string) => `/calls/${id}/enter`,
    find: '/events',
    get: (id: string) => `/events/${id}`,
    patch: (id: string) => `/events/${id}`,
    update: (id: string) => `/events/${id}`,
    updateUserStatus: (id: string) => `/events/${id}/connect`,
    users: (id: string) => `/event_users/${id}`,
    usersDeprecated: (id: string) => `/events/${id}/users`,
    zip: (id: string) => `/events/${id}/download_attachments_zip`,
  },
  files: {
    create: '/assets',
    get: '/assets',
    update: (id: string) => `/assets/${id}`,
    upload: '/file_uploads',
  },
  givings: {
    detail: (id: string) => `/givings/${id}`,
    find: '/givings',
  },
  globalSearch: {
    find: '/global_search',
    get: (scope: string) => `/global_search/${scope}`,
  },
  groups: {
    detail: (id: string) => `/groups/${id}`,
    find: '/groups',
    users: (id: string) => `/groups/${id}/users`,
  },
  kudos: {
    create: '/kudos',
    delete: (id: string) => `/kudos/${id}`,
    get: (id: string) => `/kudos/${id}`,
    update: (id: string) => `/kudos/${id}`,
  },
  notifications: {
    find: '/notifications',
    panelCounts: '/notifications/panel_counts',
    read: (id: string) => `/notifications/${id}/read`,
    readAll: '/notifications/read',
  },
  oauth: {
    magicLink: '/oauth/magic_token',
    token: '/oauth/token',
  },
  onboardingSteps: {
    complateAll: '/onboarding_steps/complete_all',
    find: '/onboarding_steps',
    update: (id: string) => `/onboarding_steps/${id}`,
  },
  organizations: {
    admins: (id: string) => `/organizations/${id}/admins`,
    detail: (id: string) => `/organizations/${id}`,
    find: '/organizations.json',
    join: (id: string) => `organizations/${id}/join`,
    public: {
      find: '/organizations/public_search',
    },
  },
  pollChoices: {
    vote: (id: string) => `/poll_choices/${id}/vote`,
  },
  polls: {
    create: '/polls',
    delete: (id: string) => `/polls/${id}`,
    get: (id: string) => `/polls/${id}`,
    update: (id: string) => `/polls/${id}`,
  },
  posts: {
    create: '/posts',
    delete: (id: string) => `/posts/${id}`,
    get: (id: string) => `/posts/${id}`,
    journal: '/posts/journal',
    markAsRead: (id: string) => `/posts/${id}/read`,
    update: (id: string) => `/posts/${id}`,
  },
  program: {
    autoComplete: '/auto_completes/program_users',
    find: '/programs',
    get: (id: string) => `/programs/${id}`,
    invite: (id: string) => `/programs/${id}/invite`,
    join: (id: string) => `/programs/${id}/join`,
    requestToJoin: (id: string) => `/programs/${id}/request`,
    users: (id: string) => `/programs/${id}/users`,
  },
  recentSearches: {
    create: '/recent_searches',
    find: '/recent_searches',
  },
  report: '/abuse_reports',
  signup: '/users',
  todos: {
    get: '/todos',
  },
  tokens: {
    generateInvitation: '/invitation_tokens',
    getInvitationToken: (invitationToken: string) => `/invitation_tokens/${invitationToken}`,
  },
  transactions: {
    checkout: (id: string) => `/transactions/${id}/checkout`,
    create: '/transactions',
    items: '/transaction_items',
    updateItem: (id: string) => `/transaction_items/${id}`,
  },
  translation: {
    get: '/translations',
  },
  user: {
    autocomplete: '/auto_completes/users',
    calendar: {
      create: '/calendar_sync',
      delete: '/calendar_sync',
      get: '/calendar_sync',
    },
    current: '/users/current',
    delete: '/users/request_delete',
    educationsLevel: '/education_levels',
    exists: '/users/exists',
    genders: '/genders',
    get: (userId: string) => `/users/${userId}`,
    interets: '/interests',
    login: '/users/login',
    loginToken: '/users/login_token',
    logout: '/users/logout',
    oauth: '/users/oauth',
    password: '/users/password',
    patch: (userId: string) => `/users/${userId}`,
    professions: '/professions',
    updatePassword: '/users/update_password',
  },
  videos: {
    create: '/videos',
    delete: (id: string) => `/videos/${id}`,
    find: '/videos',
    get: (id: string) => `/videos/${id}`,
    update: (id: string) => `/videos/${id}`,
    updateStatus: (id: string) => `/videos/${id}/update_status`,
  },
  withings: {
    createOrderPost: '/withings_order_posts.json',
    deleteOrderPost: (id: string) => `/withings_order_posts/${id}.json`,
    editOrderPost: (id: string) => `/withings_order_posts/${id}.json`,
    getOrderPost: (id: string) => `/withings_order_posts/${id}`,
    subscribe: '/withings/orders',
  },
};
